/**
 * Created by contrapro on 03/04/2018
 */

import { getJSSDKSignConfigHost, getStaticHost } from './serverUtil';
// import { vioPush } from "./crmWrapper";
import { getMobileOperatingSystem } from "./os";
import { HOST_ENV } from "../cfg";

let firstURL = '';
// let iOSInited = false;
export const initIOSUrl = () => {
    if (firstURL === '') {
        const cb = encodeURIComponent(window.location.href.split('#')[0]);
        firstURL = cb;
    }
    // alert('firstURL: ' + firstURL);
}
export const initWxJSSDK = (userObjectId, nickname, okCB, cancelCB) => {
    //console.log('========initWxJSSDK');
    // if(iOSInited) {
    //     updateJSSDK(userObjectId, nickname, okCB, cancelCB);
    //     return;
    // }

    // iOSInited = true;
    var script = document.createElement('script');
    script.onload = function () {
        // //console.log(script);
        //do stuff with the script
        // if (HOST_ENV === 'production' || window.location.origin === 'https://k11syl1-v.klub11.com')
        //     initJSSDK(window.wx, userObjectId, nickname, okCB, cancelCB);
        // else
        //     initJSSDKTest(window.wx, userObjectId, nickname, okCB, cancelCB);
        initJSSDK(window.wx, userObjectId, nickname, okCB, cancelCB);
    };
    script.src = 'https://res.wx.qq.com/open/js/jweixin-1.2.0.js';

    document.head.appendChild(script); //or something of the likes
};

export const initJSSDKAfterUserInfo = (userObjectId, nickname, okCB, cancelCB) => {
    //console.log('initJSSDKAfterUserInfo');
    initJSSDK(window.wx, userObjectId, nickname, okCB, cancelCB);
};

// var  okdddCB;
// function onShareAAOK () {
//     //console.log('onShareOK');
//     alert(okdddCB);
// }

export const updateJSSDK = (linkUrl, imgUrl, title, desc, app, time, weibo, qq, cancelCB) => {
    // okdddCB = nickname;
    // if (window.shareHelper) {
    //     const linkUrl = encodeURI(getStaticHost() + "/ufshare/?userID=" + userObjectId + "&nickname=" + nickname);
    // const linkUrl = encodeURI(getStaticHost() + "/wishShare/index.html");
    // const imgUrl = getStaticHost() + '/shareLogo.jpg';
    const data = {
        title: title,
        desc: desc,
        link: linkUrl,
        imgUrl: imgUrl,
        type: 'link',
        dataUrl: '',
        // success: okCB,
        cancel: cancelCB
    };
    window.wx.onMenuShareAppMessage(window._vio.push(["_share","haoyou", {
        ...data,
        success: app,
    }]));
    // window.wx.onMenuShareAppMessage({
    //     ...data,
    //     success: app,
    // });
    window.wx.onMenuShareTimeline(window._vio.push(["_share","pengyouquan", {
        ...data,
        success: time,
    }]));
    // window.wx.onMenuShareTimeline({
    //     ...data,
    //     success: time,
    // });
    window.wx.onMenuShareQQ(window._vio.push(["_share","qq", {
        ...data,
        success: qq,
    }]));
    // window.wx.onMenuShareQQ({
    //     ...data,
    //     success: qq,
    // });
    window.wx.onMenuShareWeibo(window._vio.push(["_share","weibo", {
        ...data,
        success: weibo,
    }]));
    // window.wx.onMenuShareWeibo({
    //     ...data,
    //     success: weibo,
    // });
};


const initJSSDK = (wwxx, userObjectId, nickname, okCB, cancelCB) => {
    // //console.log('initJSSDK', wwxx);
    const cb = window.location.href.split('#')[0];
    // const cb = window.location.href.split('#')[0];
    // alert(window.location.href.split('#')[0]);

    if (firstURL === '') {
        firstURL = cb;
    }

    const cburl = (getMobileOperatingSystem() === 'ios') ?
        encodeURIComponent(firstURL)//'http://ufstg.intplusplus.net/?userID=null&seedID=null&openid=oC2Vgv7YrQfpA4VwMEe9GZWPNR1A&unionid=o1L_JwuiZkzV4cVQVcR85rSOo3wY')
        : encodeURIComponent(cb);

    // alert('cburl: ' + cburl);

    // if (getMobileOperatingSystem()!=='ios' && iOSInited) {
    //     //console.log('cburl', cburl);
    //     const linkUrl = getStaticHost() + "/ufshare/?userID=" + userObjectId + "&nickname=" + nickname;
    //     const imgUrl = getStaticHost() + '/shareLogo.jpg';
    //     window.shareHelper.update({
    //         title: '五册那取种子吧!',
    //         desc: '立刻开始种植～ 植物成熟后将有机会领取惊喜奖品!',
    //             link: linkUrl,
    //             imgUrl: imgUrl,
    //             type: 'link',
    //             dataUrl: '',
    //             success: okCB,
    //             cancel: cancelCB
    //     });
    //     return;
    // }

    const request = require('superagent');
    request
    // .get(getJSSDKSignConfigHost())
        .get(getJSSDKSignConfigHost())
        .query({
            'account_id': 6, //server will refactor it.
            'domain_url': cb,//'http://ufstg.intplusplus.net', //'http://ufstg.intplusplus.net',//
            'debug': 1
        })
        .redirects(0)
        .end(function (err, res) {
            if (err || !res.ok) {
                //console.log('Oh no! error');
                // //console.log(err);
            } else {
                // console.log('--------yay got ', res);

                if (res.status === 200) {
                    // iOSInited = true;
                    const wxsignPackage = res.body.text.data;
                    console.log('========wxsignPackage', wxsignPackage);

                    if(wxsignPackage) {
                        wwxx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: wxsignPackage.appId, // 必填，公众号的唯一标识
                            timestamp: wxsignPackage.timestamp, // 必填，生成签名的时间戳
                            nonceStr: wxsignPackage.nonceStr, // 必填，生成签名的随机串
                            signature: wxsignPackage.signature,// 必填，签名，见附录1
                            jsApiList: wxsignPackage.jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                        });
                    }

                    wwxx.ready(function () {

                        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。

                    });

                    wwxx.error(function (res) {
                        console.log(res);
                        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。

                    });

                    // const link = encodeURI(getStaticHost() + "/wishShare/index.html");
                    const link = encodeURI(getStaticHost() + "/?share=wish&filename=mark");
                    const imgUrl = getStaticHost() + '/logoL31.png';
                    const title = 'K11沈阳咚咚仔⻢戏团开演啦!';
                    const desc = '快来获取你⾃己创作的填⾊作品，⻢上开始吧～';
                    // const app = this.onShareAppOK;
                    // const time = this.onShareTimelineOK;
                    // const weibo = this.onShareWeiboOK;
                    // const qq = this.onShareQQOK;
                    // const cancel = this.onShareCancel;
                    setTimeout( ()=> {
                        updateJSSDK(//linkUrl, imgUrl, title, desc, app, time, weibo, qq, cancelCB
                            link, imgUrl, title, desc, null, null, null, null, null
                        );

                        // console.log('vio shareData', this.makeVioSatisfy());

                    }, 800);


//                     // const wxsignPackage = JSON.parse(res.text).text.data;
//                     // //console.log('========wxsignPackage', cb, wxsignPackage );
//                     // const linkUrl = encodeURI(getStaticHost() + "/ufshare/?userID=" + userObjectId + "&nickname=" + nickname);
//                     const linkUrl = encodeURI(getStaticHost() + "/ufshare/?userID=" + userObjectId + "&nickname=" + nickname);
//                     const imgUrl = getStaticHost() + '/shareLogo.jpg';
//                     window.shareCount = 0;
//                     window.shareHelper = false;
//                     var ShareHelper = function (wx) {
//                         // //console.log('wx',wx);
//                         return {
//                             shareData: {
//                                 link: linkUrl,
//                                 imgUrl: imgUrl,
//                                 title: '快来光谷K11都市农庄领取种子吧!',
//                                 desc: '立刻开始种植～ 植物成熟后将有机会领取惊喜奖品!',
//                                 success: function () {
//                                     // alert('on init success');
//                                     if (okCB) okCB();
// //                    increaseShareCount();
//                                 },
//                                 cancel: function () {
//                                     // alert('on init cancel');
//                                     if (cancelCB) cancelCB();
//                                 }
//                             },
//                             config: function (opts) {
//                                 wx.config(opts)
//                             },
//                             shareInit: function (data) {
//                                 data = data || this.shareData;
//                                 // wx.onMenuShareAppMessage({
//                                 //     title: data.title,
//                                 //     desc: data.desc,
//                                 //     link: data.link,
//                                 //     imgUrl: data.imgUrl,
//                                 //     type: 'link',
//                                 //     dataUrl: '',
//                                 //     success: data.success,
//                                 //     cancel: data.cancel
//                                 // });
//                                 // wx.onMenuShareTimeline({
//                                 //     title: data.title,
//                                 //     desc: data.desc,
//                                 //     link: data.link,
//                                 //     imgUrl: data.imgUrl,
//                                 //     type: 'link',
//                                 //     dataUrl: '',
//                                 //     success: data.success,
//                                 //     cancel: data.cancel
//                                 // });
//                                 // wx.onMenuShareQQ({
//                                 //     title: data.title,
//                                 //     desc: data.desc,
//                                 //     link: data.link,
//                                 //     imgUrl: data.imgUrl,
//                                 //     type: 'link',
//                                 //     dataUrl: '',
//                                 //     success: data.success,
//                                 //     cancel: data.cancel
//                                 // });
//                                 // wx.onMenuShareWeibo({
//                                 //     title: data.title,
//                                 //     desc: data.desc,
//                                 //     link: data.link,
//                                 //     imgUrl: data.imgUrl,
//                                 //     type: 'link',
//                                 //     dataUrl: '',
//                                 //     success: data.success,
//                                 //     cancel: data.cancel
//                                 // });
//                                 // wx.onMenuShareAppMessage(window._vio.push(["_share","talk", data]));
//                                 // wx.onMenuShareTimeline(window._vio.push(["_share","wechat", data]));
//                                 // wx.onMenuShareQQ(window._vio.push(["_share","qq", data]));
//                                 // wx.onMenuShareWeibo( window._vio.push(["_share","weibo", data]) );
//                                 return this;
//                             },
//                             update: function (data) {
//                                 return this.shareInit(data);
//                             },
//                             reset: function () {
//                                 return this.shareInit(this.shareData);
//                             },
//                             init: function (config, data) {
//                                 var _ = this;
//                                 //继承设置
//                                 if (data) {
//                                     for (var key in data) {
//                                         _.shareData[key] = data[key];
//                                     }
//                                 }
//                                 _.config(config);
//                                 wx.ready(function () {
//                                     _.shareInit()
//                                 });
//                                 return _;
//                             }
//                         };
//                     };
//
//                     if (!window.shareHelper) {
//                         // //console.log('------wxsignPackage in shareHelper init', wxsignPackage);
//                         window.shareHelper = ShareHelper(wwxx);
//                         window.shareHelper.init({
//                             "debug": false,
//                             "beta": false,
//                             "appId": wxsignPackage.appId,
//                             "timestamp": String(wxsignPackage.timestamp),
//                             "nonceStr": wxsignPackage.nonceStr,
//                             "signature": wxsignPackage.signature,
//                             "url": wxsignPackage.url, //TODO
//                             "jsApiList": ['onMenuShareQQ', 'onMenuShareWeibo', "onMenuShareTimeline", "onMenuShareAppMessage"]//wxsignPackage.jsApiList//
//                         }, {
//                             link: linkUrl,
//                             imgUrl: imgUrl,//这里用计算公式不灵，写死
//                             title: '快来光谷K11都市农庄领取种子吧!',
//                             desc: '立刻开始种植～ 植物成熟后将有机会领取惊喜奖品!',
//                             //    success: okCB,
//                             //  cancel: cancelCB
//                             success: function () {
//                                 // alert('on init success');
//                                 if (okCB) okCB();
// //                    increaseShareCount();
//                             },
//                             cancel: function () {
//                                 // alert('on init cancel');
//                                 if (cancelCB) cancelCB();
//                             }
//                         });
//                     }
                }
            }
        });


}


const initJSSDKTest = (wwxx, userObjectId, nickname, okCB, cancelCB) => {
    // //console.log('initJSSDK', wwxx);
    const cb = window.location.href.split('#')[0];
    // const cb = window.location.href.split('#')[0];
    // alert(window.location.href.split('#')[0]);

    if (firstURL === '') {
        firstURL = cb;
    }

    const cburl = (getMobileOperatingSystem() === 'ios') ?
        encodeURIComponent(firstURL)//'http://ufstg.intplusplus.net/?userID=null&seedID=null&openid=oC2Vgv7YrQfpA4VwMEe9GZWPNR1A&unionid=o1L_JwuiZkzV4cVQVcR85rSOo3wY')
        : encodeURIComponent(cb);

    // alert('cburl: ' + cburl);

    // if (getMobileOperatingSystem()!=='ios' && iOSInited) {
    //     //console.log('cburl', cburl);
    //     const linkUrl = getStaticHost() + "/ufshare/?userID=" + userObjectId + "&nickname=" + nickname;
    //     const imgUrl = getStaticHost() + '/shareLogo.jpg';
    //     window.shareHelper.update({
    //         title: '五册那取种子吧!',
    //         desc: '立刻开始种植～ 植物成熟后将有机会领取惊喜奖品!',
    //             link: linkUrl,
    //             imgUrl: imgUrl,
    //             type: 'link',
    //             dataUrl: '',
    //             success: okCB,
    //             cancel: cancelCB
    //     });
    //     return;
    // }

    const request = require('superagent');
    request
    // .get(getJSSDKSignConfigHost())
        .get(getJSSDKSignConfigHost() + '&cb=' + cburl)
        // .query({
        //     'account_id': 6,
        //     'domain_url': 'http://ufstg.intplusplus.net', //'http://ufstg.intplusplus.net',//
        //     'debug': 1
        // })
        .redirects(0)
        .end(function (err, res) {
            if (err || !res.ok) {
                //console.log('Oh no! error');
                // //console.log(err);
            } else {
                //console.log('--------yay got ', res.text);

                if (res.status === 200) {
                    // iOSInited = true;
                    const wxsignPackage = JSON.parse(res.text);
                    //console.log('========wxsignPackage', wxsignPackage.url);

                    // const wxsignPackage = JSON.parse(res.text).text.data;
                    // //console.log('========wxsignPackage', cb, wxsignPackage );
                    const linkUrl = encodeURI('https://k11syl1.intplusplus.net' + "/wishShare/index.html");
                    const imgUrl = 'https://k11syl1.intplusplus.net' + '/logo28.png';
                    const title = 'K11许愿池';
                    const desc = 'K11许愿池';
                    window.shareCount = 0;
                    window.shareHelper = false;
                    var ShareHelper = function (wx) {
                        // //console.log('wx',wx);
                        return {
                            shareData: {
                                link: linkUrl,
                                imgUrl: imgUrl,
                                title: title,
                                desc: desc,
                                success: function () {
                                    // alert('on init success');
                                    if (okCB) okCB();
//                    increaseShareCount();
                                },
                                cancel: function () {
                                    // alert('on init cancel');
                                    if (cancelCB) cancelCB();
                                }
                            },
                            config: function (opts) {
                                wx.config(opts)
                            },
                            shareInit: function (data) {
                                data = data || this.shareData;
                                // wx.onMenuShareAppMessage({
                                //     title: data.title,
                                //     desc: data.desc,
                                //     link: data.link,
                                //     imgUrl: data.imgUrl,
                                //     type: 'link',
                                //     dataUrl: '',
                                //     success: data.success,
                                //     cancel: data.cancel
                                // });
                                // wx.onMenuShareTimeline({
                                //     title: data.title,
                                //     desc: data.desc,
                                //     link: data.link,
                                //     imgUrl: data.imgUrl,
                                //     type: 'link',
                                //     dataUrl: '',
                                //     success: data.success,
                                //     cancel: data.cancel
                                // });
                                // wx.onMenuShareQQ({
                                //     title: data.title,
                                //     desc: data.desc,
                                //     link: data.link,
                                //     imgUrl: data.imgUrl,
                                //     type: 'link',
                                //     dataUrl: '',
                                //     success: data.success,
                                //     cancel: data.cancel
                                // });
                                // wx.onMenuShareWeibo({
                                //     title: data.title,
                                //     desc: data.desc,
                                //     link: data.link,
                                //     imgUrl: data.imgUrl,
                                //     type: 'link',
                                //     dataUrl: '',
                                //     success: data.success,
                                //     cancel: data.cancel
                                // });
                                // wx.onMenuShareAppMessage(window._vio.push(["_share","talk", data]));
                                // wx.onMenuShareTimeline(window._vio.push(["_share","wechat", data]));
                                // wx.onMenuShareQQ(window._vio.push(["_share","qq", data]));
                                // wx.onMenuShareWeibo( window._vio.push(["_share","weibo", data]) );
                                return this;
                            },
                            update: function (data) {
                                return this.shareInit(data);
                            },
                            reset: function () {
                                return this.shareInit(this.shareData);
                            },
                            init: function (config, data) {
                                var _ = this;
                                //继承设置
                                if (data) {
                                    for (var key in data) {
                                        _.shareData[key] = data[key];
                                    }
                                }
                                _.config(config);
                                wx.ready(function () {
                                    _.shareInit()
                                });
                                return _;
                            }
                        };
                    };

                    if (!window.shareHelper) {
                        // //console.log('------wxsignPackage in shareHelper init', wxsignPackage);
                        window.shareHelper = ShareHelper(wwxx);
                        window.shareHelper.init({
                            "debug": false,
                            "beta": false,
                            "appId": wxsignPackage.appId,
                            "timestamp": String(wxsignPackage.timestamp),
                            "nonceStr": wxsignPackage.nonceStr,
                            "signature": wxsignPackage.signature,
                            "url": wxsignPackage.url, //TODO
                            "jsApiList": ['onMenuShareQQ', 'onMenuShareWeibo', "onMenuShareTimeline", "onMenuShareAppMessage"]//wxsignPackage.jsApiList//
                        }, {
                            link: linkUrl,
                            imgUrl: imgUrl,//这里用计算公式不灵，写死
                            title: title,
                            desc: desc,
                            //    success: okCB,
                            //  cancel: cancelCB
                            success: function () {
                                // alert('on init success');
                                if (okCB) okCB();
//                    increaseShareCount();
                            },
                            cancel: function () {
                                // alert('on init cancel');
                                if (cancelCB) cancelCB();
                            }
                        });
                    }
                }
            }
        });


}
//https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx8557459494a0dfbd&redirect_uri=https%3a%2f%2funderarmour.applinzi.com&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect

// export const getToken = (code)=>{
//     let reqUrl = 'https://api.weixin.qq.com/sns/oauth2/access_token?';
//     let params = {
//         appid: 'wx8557459494a0dfbd',
//         secret: config.appSecret,
//         code: code,
//         grant_type: 'authorization_code'
//     };
//
//     let options = {
//         method: 'get',
//         url: reqUrl+qs.stringify(params)
//     };
//     //console.log(options.url);
//     return new Promise((resolve, reject) => {
//         request(options, function (err, res, body) {
//             if (res) {
//                 resolve(body);
//             } else {
//                 reject(err);grant_type
//             }
//         })
//     })
// };



// WEBPACK FOOTER //
// ./src/util/wxUtil.js